import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const fileUrl = (id) => (id ? `${API}/files/${id}` : null);

const inr = (n) => Number(n || 0).toLocaleString("en-IN");
export function formatSalary(j) {
  if (!j?.salary_max && !j?.salary_min) return "Not disclosed";
  if (j.salary_period === "month") {
    const a = Math.round(j.salary_min / 12), b = Math.round(j.salary_max / 12);
    return a === b ? `₹${inr(a)}/month` : `₹${inr(a)} – ${inr(b)}/month`;
  }
  const l = (v) => +(v / 100000).toFixed(1);
  return l(j.salary_min) === l(j.salary_max) ? `₹${l(j.salary_max)} LPA` : `₹${l(j.salary_min)} – ${l(j.salary_max)} LPA`;
}

export const WORK_MODES = { onsite: "On-site", remote: "Remote", hybrid: "Hybrid" };
export const JOB_TYPES = { "full-time": "Full-time", "part-time": "Part-time", internship: "Internship", contract: "Contract", freelance: "Freelance" };
export const EDUCATION = { any: "Any", "10th": "10th pass", "12th": "12th pass", diploma: "Diploma / ITI", graduate: "Graduate", postgraduate: "Post-graduate" };
export const STATUS_META = {
  applied: { label: "Applied", cls: "bg-slate-100 text-slate-700" },
  shortlisted: { label: "Shortlisted", cls: "bg-blue-50 text-blue-700" },
  interview_scheduled: { label: "Interview Scheduled", cls: "bg-amber-50 text-amber-700" },
  selected: { label: "Selected", cls: "bg-[#EAF8EF] text-[#009a41]" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-600" },
  withdrawn: { label: "Withdrawn", cls: "bg-slate-100 text-slate-500" },
};
export const expLabel = (j) => (j.experience_min === 0 && !j.experience_max ? "Fresher" : j.experience_min === 0 ? `0–${j.experience_max} yrs` : `${j.experience_min}${j.experience_max ? `–${j.experience_max}` : "+"} yrs`);
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const timeAgo = (s) => {
  const d = (Date.now() - new Date(s).getTime()) / 86400000;
  return d < 1 ? "Today" : d < 2 ? "Yesterday" : d < 30 ? `${Math.floor(d)} days ago` : fmtDate(s);
};
export const download = async (path, filename) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
